<template>
  <div class="urgency-message flex-inline" :style="`--color: ${color || '#207944'};`">
    <LazySvgTemplate v-if="svgIsEnabled && svgName" :svg-name="svgName" :name="svgName" class="icon" />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span class="message" v-html="urgencyMessaging.message" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  urgencyMessaging: {
    type: Object as () => any,
    required: true,
  },
  svgIsEnabled: {
    type: Boolean,
    default: true,
  },
});

const svgName = props.urgencyMessaging?.svg || 'time-line';

const color = computed(() => props.urgencyMessaging?.color_hex_);
</script>

<style scoped>
.urgency-message {
  color: var(--color);
}
.urgency-message :deep(svg) {
  fill: var(--color);
}
</style>

<style lang="scss">
.urgency-message {
  font-size: 0.875rem;
  margin-top: 1rem;
  .message,
  .message p {
    @include local-mixins.ff-text-65;
    margin-bottom: unset;
    line-height: 1.25;
  }
  .svg-comp-wrapper {
    margin-right: 4px;
  }
}
.cart-modal .urgency-message {
  .message,
  .message p {
    font-size: 0.75rem;
  }
}
</style>
